const keys = {
  house: 'house',
  communications: 'communications',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  leisure: 'leisure',
  health: 'health',
}

const config = {
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Are you cohabiting?',
      answers: {
        A: 'I live on my own',
        B: 'I live with my partner'
      },
      images: {
        Q1AA: 'Q1-AA.jpg',
        Q1AB: 'Q1-AB.jpg',
      }
    },
    single: {
      [keys.house]: {
        question: 'Describe your home in retirement',
        answers: {
          A: 'Limited budget for heating and home repairs',
          B: 'Well furnished - I can afford household expenses and basic maintenance',
          C: 'I like to redecorate and do home improvements',
        },
        images: {
          Q2AC: 'Q2-AC.jpg',
          Q2AB: 'Q2-AB.jpg',
          Q2AA: 'Q2-AA.jpg',
        }
      },
      [keys.communications]: {
        question: 'Will you use wifi and streaming services?',
        answers: {
          A: 'Very basic mobile and limited internet connectivity',
          B: 'Basic mobile and modest internet data allowance',
          C: 'High-speed internet, Netflix, Spotify and gaming',
        },
        images: {
          Q3AA: 'Q3-AA.jpg',
          Q3AB: 'Q3-AB.jpg',
          Q3AC: 'Q3-AC.jpg',
        }
      },
      [keys.food]: {
        question: "Where do you go grocery shopping?",
        answers: {
          A: "I buy from my local discount supermarket",
          B: "I purchase premium brands from mainstream supermarkets",
          C: "I only choose organic, local produce and shop from speciality stores",
        },
        images: {
          Q4AA: 'Q4-AA.jpg',
          Q4AB: 'Q4-AB.jpg',
          Q4AC: 'Q4-AC.jpg',
        }
      },
      [keys.eatout]: {
        question: "You're eating out... where are you heading?",
        answers: {
          A: 'The local club senior meals or cheap take-away',
          B: 'Affordable restaurant meals or take-away meals every other week',
          C: 'Enjoy quality meals at a nice restaurant',
        },
        images: {
          Q5AA: 'Q5-AA.jpg',
          Q5AB: 'Q5-AB.jpg',
          Q5AC: 'Q5-AC.jpg',
        }
      },
      [keys.transport]: {
        question: 'How are you going to get around?',
        answers: {
          A: "I'll use public transport",
          B: "I'm happy with an older model car",
          C: "Comfort is key for me - I'd like a mid-range car",
        },
        images: {
          Q6AA: 'Q6-AA.jpg',
          Q6AB: 'Q6-AB.jpg',
          Q6AC: 'Q6-AC.jpg',
        }
      },
      [keys.holiday]: {
        question: 'Are you planning to do much travelling?',
        answers: {
          A: 'An occasional short break or a day trip in my own city',
          B: 'Annual interstate trip or a few short breaks',
          C: 'Visit my family interstate and an overseas trip every few years',
        },
        images: {
          Q7AA: 'Q7-AA.jpg',
          Q7AB: 'Q7-AB.jpg',
          Q7AC: 'Q7-AC.jpg',
        }
      },
      [keys.leisure]: {
        question: "You're heading out, what would you like to do?",
        answers: {
          A: 'A day at the beach',
          B: 'A trip to the cinema',
          C: 'Attend a concert or sporting event',
        },
        images: {
          Q8AA: 'Q8-AA.jpg',
          Q8AB: 'Q8-AB.jpg',
          Q8AC: 'Q8-AC_guild.jpg',
        }
      },
      [keys.personal]: {
        question: 'Will you treat yourself to new clothes and self care?',
        answers: {
          A: "I'm pretty low maintenance",
          B: "I've got a limited budget to replace or update worn items",
          C: "I like to look good - I'll splash out occasionally",
        },
        images: {
          Q9AA: 'Q9-AA.jpg',
          Q9AB: 'Q9-AB.jpg',
          Q9AC: 'Q9-AC.jpg',
        }
      },
      [keys.health]: {
        question: "What level of health care do you need?",
        answers: {
          A: 'I mainly rely on the public health care system',
          B: 'I have basic private health insurance, limited gap payments',
          C: 'I have comprehensive private health insurance',
        },
        images: {
          Q10AA: 'Q10-AA.jpg',
          Q10AB: 'Q10-AB.jpg',
          Q10AC: 'Q10-AC.jpg',
        }
      },
    },
    // uncomment and populate below if we ever add different question/answer copy. Will also need to update config/index.js getQuestionAnswerData getter
    // cohabiting: {
    //   [keys.house]: {},
    //   [keys.transport]: {},
    //   [keys.personal]: {},
    //   [keys.eatout]: {},
    //   [keys.holiday]: {},
    //   [keys.food]: {},
    //   [keys.treat]: {},
    // }
  },
  currencySymbol: '$',
  inputs: {
    age: {
      min: 18,
      max: 100,
      currentValue: 20, // initial value
    },
    retirementAge: {
      min: 50,
      max: 100,
      currentValue: 70, //initial value
    },
    currentBalance: {
      min: 0,
      max: 1000000,
      currentValue: 0,  //initial value
    },
  },
  engine: {
    interestRate: 0.04,
    statePension: 9627.80,
    annuityRate: 20,
  }
};

export default config;
